import type { FaireProductEntity } from "../../entity_types/product";

export const p_vfrzu3g2vw: FaireProductEntity = {
  token: "p_vfrzu3g2vw",
  type: "product",
  name: "Maple Fudge with Captain Crazy’s Nuts and Fine Snacks Maple Bourbon Brown Sugar Pecans",
  brandToken: "b_xtvv45q74f",
  brandName: "Meem's Fudge Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/dec9b8abfce8714f73a2449a899dde69523a7b0f68adfb6860bd46637b7a42af.png",
  galleryImageUrls: [],
  priceDollars: 4.5,
  description:
    "We thought our 100% Real Maple Syrup Maple Fudge couldn't be topped, but then, we met the crew from Captain Crazy's Nuts and Fine Snacks and found a way to take it to a whole 'nother level! We use the Captain's Bourbon Brown Sugar roasted Pecans, roasted by the captain himself in this delightful concoction of White Chocolate, Real Maple Syrup and Bourbon notes with a Pecan crunch.\n",
  tags: [],
  msrpDollars: 9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:28.190Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
